import { Injectable } from "@angular/core";
import { ReferentialEntity } from "../models/referential-entity";
import { ApiService } from "./api.service";
import { FiltersStateInterface } from "../store/actions/filters.actions";

@Injectable()
export class FiltersService {
  public selectedReferentialEntities: ReferentialEntity[];

  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  /**
   * Initialize service
   */
  constructor(private apiService: ApiService) {}

  /**
   * Initialize the selected referential entities with an empty array
   */
  init() {
    this.selectedReferentialEntities = [];
  }

  /**
   * Clear the selected referential entities
   */
  clear() {
    this.init();
  }

  /**
   * Add a referential entity selected
   * @param {ReferentialEntity} referentialEntity
   */
  addEntity(referentialEntity: ReferentialEntity) {
    this.selectedReferentialEntities.push(referentialEntity);
  }

  /**
   * Remove a referential entity from the selected array
   * @param {ReferentialEntity} referentialEntity
   */
  removeEntity(referentialEntity: ReferentialEntity) {
    this.selectedReferentialEntities = this.selectedReferentialEntities.filter(
      (entity) => {
        return (
          entity.id !== referentialEntity.id ||
          entity.id !== referentialEntity.id
        );
      }
    );
  }

  /**
   * Get filter for the current User
   */
  getUserFilter() {
    return this.apiService.get("Filter/GetUserFilter");
  }

  /**
   * Save filter for the current User
   */
  saveUserFilter(filters: FiltersStateInterface) {
    return this.apiService.post("Filter/SaveUserFilter", filters);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/filters.service.ts